import { LocationProviderContext } from "./LocationProviderContext";
import { useEffect, useMemo, useRef, useState } from "react";
import appHistory from "../../app/appHistory";

function LocationProvider(props) {
    const {children} = props;

    const currentLocation = useRef(appHistory.location);
    const [prevLocation, setPrevLocation] = useState({});

    useEffect(() => {
        appHistory.listen((location) => {
            setPrevLocation(currentLocation.current);
            currentLocation.current = location;
        });
    }, []);

    const value = useMemo(() => ({ prevLocation }), [prevLocation]);

    return <LocationProviderContext.Provider value={value}>
        {children}
    </LocationProviderContext.Provider>
}

export default LocationProvider;
